export default {
  emptyText: 'Kein Hallen-Layout ausgewählt',
};
